import React from 'react';
import Container from './ui/Container';
import { Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12">
      <Container>
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center">
            <p className="text-sm">
              © 2025 - Made with <Heart className="w-4 h-4 text-red-500 inline mx-1" /> by Sara
            </p>
          </div>
          <div className="flex gap-8">
            <a href="https://www.iubenda.com/privacy-policy/21505067" className="text-sm hover:text-white transition-colors" target='_blank'>
              Privacy Policy
            </a>
            <a href="https://www.iubenda.com/privacy-policy/21505067/cookie-policy" className="text-sm hover:text-white transition-colors" target='_blank'>
              Cookie Policy
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;